import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
} from '@material-ui/core';

import { addProductGroup } from 'redux/actions';
import { category, company } from 'variables/expenseTypes';

const ProductGroupDetails = ({isCategory, ...props}) => {

  const [groupName, setGroupName] = useState("");

  const groupType = isCategory ? "Category" : "Brand";

  const handleSubmit = (e) => {
    e.preventDefault();

    const newGroup = {
      name: groupName,
      type: ( isCategory ? category : company )
    };
    props.addProductGroup(newGroup);
    
    productGroupCleanup();
  };

  const productGroupCleanup = () => {
    setGroupName("");
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader={`This will add a New Product ${groupType}`}
          title={`New Product ${groupType}`}
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
            direction="column"
            alignItems="center"
          >
            <Grid
              item
              md={6}
              xs={12}
              style={{ width: '50%' }}
            >
              <TextField
                fullWidth
                helperText={`Please Enter the ${groupType}`}
                label={`Product ${groupType}`}
                onChange={(event) => setGroupName(event.target.value)}
                required
                value={groupName}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
          <Button sx={{ mx: 1 }} onClick={productGroupCleanup}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  );
};

export default connect (null, {addProductGroup}) (ProductGroupDetails);
